import AxiosService from '../AxiosService';

const campaignsDataGet = async () => {
  const instance = AxiosService.createCampaignsAxiosInstance();
  const response = await instance.get('/v1/campaigns/flexibles/campaigns/data');
  return response.data;
};

const bannersDataGet = async (audience?: {subchannel: string; figure: string}) => {
  const instance = AxiosService.createCampaignsAxiosInstance();
  const response = await instance.get('/v1/client/banners/getAll', {
    params: audience,
  });
  return response.data;
}

export default {
  campaignsDataGet,
  bannersDataGet
};
